import React, { useState, useEffect } from 'react';

// Date cible : 28 août 2026 à 18h00
const TARGET_DATE = new Date('2026-08-28T18:00:00').getTime();

const calculateTimeLeft = () => {
  const diff = TARGET_DATE - Date.now();
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, finished: true };
  }
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    finished: false,
  };
};

const Countdown = () => {
  const [time, setTime] = useState(calculateTimeLeft);

  useEffect(() => {
    const id = setInterval(() => setTime(calculateTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  if (time.finished) {
    return (
      <div className="text-center text-orange-400 text-sm font-semibold tracking-wide" data-testid="countdown">
        🔥 La soirée est lancée ! 🔥
      </div>
    );
  }

  const Unit = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <span className="text-base md:text-lg font-bold text-orange-400 tabular-nums">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] uppercase tracking-wider text-gray-400">{label}</span>
    </div>
  );

  return (
    <div
      data-testid="countdown"
      className="inline-flex items-center gap-3 md:gap-4 bg-black/50 backdrop-blur-sm px-4 py-2 rounded-full border border-orange-600/30"
    >
      <span className="text-[10px] uppercase tracking-widest text-orange-300/80 hidden md:inline">
        J-
      </span>
      <Unit value={time.days} label="jours" />
      <span className="text-orange-400/60">:</span>
      <Unit value={time.hours} label="h" />
      <span className="text-orange-400/60">:</span>
      <Unit value={time.minutes} label="min" />
      <span className="text-orange-400/60">:</span>
      <Unit value={time.seconds} label="sec" />
    </div>
  );
};

export default Countdown;
